<template>
  <StandardLayout style="text-align: center;">
    <div>Micad Analytics Centre</div>
  </StandardLayout>
</template>

<script>
  import StandardLayout from '@/components/layout/standard/StandardLayout.vue'

  export default {
    name: 'Home',
    components: {
      StandardLayout,
    },
    methods: {
    },
    created() {
      this.$router.push({name: 'dashboards'})
    }
  }
</script>
